/**
 * IMPORTS
 */

import { useMutation } from "@tanstack/react-query";

import {
  ICreateClientAddressPayload,
  ICreateClientAddressResponse,
} from "@/hooks/enderecos/criar/index.d";

import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { handleCreateNovoEndereco } from "@/domain/use-cases/enderecos-usuarios";

/**
 * Função criar um endereço relacionado com um usuário
 * @payload
 * @returns
 */
export function useCriarEnderecoUsuario() {
  const { token } = useStoreZustandUserAuth();

  const mutation = useMutation<ICreateClientAddressResponse, Error, ICreateClientAddressPayload>({
    mutationFn: async (payload) => {
      return await handleCreateNovoEndereco(token!, payload);
    },
  });

  return {
    criarEndrecoUsuario: mutation.mutate,
    criarEndrecoUsuarioAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    isSuccess: mutation.isSuccess,
  };
}
